import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  colors: {
    background: {
      secondary: "#000",
      primary: "#0c0c0c",
    },
    text: {
      primary: "#A1A1A1",
      secondary: "#F2F2F2",
      tertiary: "#BDBDBD", // ???
      button: {
        dark: "#0C0C0C",
      },
    },
  },
};
